<template>
  <div class="data-fragment">
    <keep-alive>
      <AsyncComponent v-if="fragmentPath"
                      :key="fragment.postId"
                      :component-path="fragmentPath"
                      v-bind="fragment"
                      @back="handleBack"></AsyncComponent>
    </keep-alive>
  </div>
</template>

<script>
import AsyncComponent from '../../elements/async/AsyncComponent'
export default {
  name: 'DataFragment',
  inject: ['$fragment'],
  components: {
    AsyncComponent
  },
  data () {
    return {
      fragment: {
        pathMatch: this.$attrs['pathMatch'],
        postId: ''
      }
    }
  },
  computed: {
    fragmentPath () {
      if (this.fragment.pathMatch) {
        return `pages/fragment/${this.fragment.pathMatch}`
      }
    }
  },
  methods: {
    handleInit () {
      this.fragment.postId = this.$route.query['postId'] || ''
      this.$fragment.saveFragment(this.fragment)
    },
    handleBack () {
      this.$fragment.hideFragment()
    }
  },
  mounted () {
    this.handleInit()
  },
  activated () {
    this.handleInit()
  }
}
</script>

<style lang="scss">
  .data-fragment {
    height: 100%;
  }
</style>
